import React from 'react';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

import { Sidebar } from '../';
import SidebarLink from '../components/SidebarLink';

import Profile from 'material-ui/svg-icons/action/account-circle';
import Groups from 'material-ui/svg-icons/action/supervisor-account';
import Users from 'material-ui/svg-icons/social/person';
import Account from 'material-ui/svg-icons/action/settings';
import Feedback from 'material-ui/svg-icons/action/announcement';

import { appContainer, Subscribe } from '../../../contexts/app';
import { UserAccountContext } from '../../../contexts/userAccount';
import './style.scss';

class SidebarAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  render() {
    let { currentUser, subscriptionStatus } = this.props;
    let { permissions } = currentUser;
    let { active } = subscriptionStatus;
    return (
      <div id="SidebarAccount">
        <Sidebar>
          <div style={{ width: '100%' }}>
            <MenuItem
              containerElement={<SidebarLink to={'/account'} />}
              rightIcon={<Profile />}
            >
              My Profile
            </MenuItem>
            {permissions.edit.account && (
              <div>
                <Divider />
                <MenuItem
                  containerElement={<SidebarLink to={'/account/settings'} />}
                  rightIcon={<Account />}
                >
                  Organization
                </MenuItem>
              </div>
            )}
            {permissions.edit.users &&
              active && (
                <div>
                  <div>
                    <Divider />
                    <MenuItem
                      containerElement={<SidebarLink to={'/account/users'} />}
                      rightIcon={<Users />}
                    >
                      Users
                    </MenuItem>
                  </div>
                  <div>
                    <Divider />
                    <MenuItem
                      containerElement={<SidebarLink to={'/account/groups'} />}
                      rightIcon={<Groups />}
                    >
                      Groups
                    </MenuItem>
                  </div>
                </div>
              )}
            <Divider />
            {active ? (
              <MenuItem
                containerElement={<SidebarLink to={'/account/feedback'} />}
                rightIcon={<Feedback />}
              >
                Give Feedback
              </MenuItem>
            ) : null}
            <Divider />
          </div>
        </Sidebar>
      </div>
    );
  }
}

SidebarAccount.propTypes = {};

export default props => {
  return (
    <UserAccountContext.Consumer>
      {({ subscriptionStatus }) => (
        <Subscribe
          to={[appContainer]}
          render={app => {
            return (
              <SidebarAccount
                {...props}
                subscriptionStatus={subscriptionStatus}
                currentUser={app.state.get('currentUser')}
              />
            );
          }}
        />
      )}
    </UserAccountContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarAccount/index.jsx